export default __webpack_public_path__ + "static/home-background-xl-2830bba21e0a0627fb274a77629831ad.jpg";